import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Zap, Gauge, Package } from 'lucide-react';
import { TransformerImage } from '../TransformerImage';
import { generateSeoUrl } from '../../utils/seo';
import { Transformer } from '../../types/transformer';

interface TransformerCardProps {
  transformer: Transformer;
  isLoading?: boolean;
}

export const TransformerCard: React.FC<TransformerCardProps> = ({
  transformer,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
        <div className="h-48 bg-gray-200 rounded-lg mb-4" />
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-4" />
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-5/6" />
          <div className="h-4 bg-gray-200 rounded w-4/6" />
        </div>
      </div>
    );
  }

  const imageUrl = transformer.image
    ? `/images/transformers/${transformer.image}.jpg`
    : '/images/transformers/default.jpg';

  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden transform hover:scale-105 transition-transform duration-200">
      <Link to={generateSeoUrl(transformer)} className="block">
        <div className="aspect-w-16 aspect-h-9">
          <TransformerImage
            src={imageUrl}
            alt={transformer.name || 'Трансформатор'}
            width={600}
            height={450}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-6">
          <h2 className="text-xl font-semibold mb-2">{transformer.name}</h2>

          <div className="space-y-2 text-sm text-gray-600 mb-4">
            <div className="flex items-center">
              <Zap className="h-4 w-4 mr-2 text-primary-500" />
              <span>Мощность: {transformer.power} кВА</span>
            </div>
            <div className="flex items-center">
              <Gauge className="h-4 w-4 mr-2 text-primary-500" />
              <span>Напряжение: {transformer.voltage} кВ</span>
            </div>
            <div className="flex items-center">
              <Shield className="h-4 w-4 mr-2 text-primary-500" />
              <span>Защита: {transformer.protection}</span>
            </div>
            <div className="flex items-center">
              <Package className="h-4 w-4 mr-2 text-primary-500" />
              <span>Материал: {transformer.material}</span>
            </div>
          </div>

          <div className="flex items-center text-primary-600 font-medium">
            <span>Подробнее</span>
            <ArrowRight className="h-4 w-4 ml-2" />
          </div>
        </div>
      </Link>
    </article>
  );
};

export default TransformerCard;
